import * as React from "react";
import { Form as AntForm } from "antd";
import { withFormik, FormikProps, Field, Form } from "formik";
import { loginSchema } from "@njoy/common";
import { Link } from "react-router-dom";
import { NormalizedErrorMap } from "@njoy/controller";
import NewButton from "../../../../components/uiMerge/newButton";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { InputField } from "../../../shared/InputField";
import { BrandLogo } from "../../../../components/shared/BrandLogo";
import ToastMessage from "../../../../hooks/useToast";
import { extractError } from "../../../../utils/extractError";

const FormItem = AntForm.Item;

interface FormValues {
  email: string;
  password: string;
}

interface Props {
  onFinish: () => void;
  submit: (values: FormValues) => Promise<NormalizedErrorMap | null>;
}

class C extends React.PureComponent<FormikProps<FormValues> & Props> {
  render() {
    return (
      <>
        <ToastContainer />

        <div className="px-[1rem] pt-10 pb-2 text-white">
          <Link to={"/"}>
            <BrandLogo className="mx-auto m-5" width={133} height={52} />
          </Link>
          <div className="flex flex-row " />

          <div className="" >
            <br />

            <Form>
              <div>
                <label className="text-[#CECECF] opacity-90" htmlFor="email">
                  Email Address
                </label>
                <Field name="email" placeholder="Email Address" component={InputField} />
                <label className="text-[#CECECF] opacity-90" htmlFor="password">
                  Password
                </label>
                <Field
                  name="password"
                  type="password"
                  placeholder="Enter Your Password"
                  component={InputField}
                  
                />
                <div className=" flex  flex-row w-full justify-end " style={{marginBottom:"18px"}}>
                  <Link to={"/forgot-password"}>
                    <p className="text-[#8E8E8E] text-[14px] cursor-pointer">
                      Forgot Password?
                    </p>
                  </Link>
                </div>

                <FormItem>
                  <NewButton
                    loading={this.props.isSubmitting}
                    fullWidth
                    variant="primary"
                    type="submit"
                    className="login-form-button"
                  >
                    Sign In
                  </NewButton>
                </FormItem>
                <FormItem className="">
                  <div className="flex flex-row m-1 p-2 w-full justify-center">
                    <span className="font-medium  text-white">
                      Don&apos;t have an account?{" "}
                    </span>

                    <span>
                      {"  "}
                      <Link
                        className=" text-[color:var(--brand-primary)] cursor-pointer"
                        to={"/register"}
                      >
                        &nbsp;Sign Up{" "}
                      </Link>
                    </span>
                  </div>
                </FormItem>
              </div>
            </Form>
          </div>
        </div>
      </>
    );
  }
}

export const LoginView = withFormik<Props, FormValues>({
  validationSchema: loginSchema,
  validateOnChange: false,
  validateOnBlur: false,
  mapPropsToValues: () => ({ email: "", password: "" }),
  handleSubmit: async (values, { props, setErrors, setSubmitting }) => {
    try {
      setSubmitting(true);
      const serverErrors = await props.submit(values);

      if (serverErrors) {
        setSubmitting(false);
        ToastMessage("error", extractError(serverErrors));
        setErrors(serverErrors);
        return;
      }

      setSubmitting(false);
      props.onFinish();
    } catch (error: any) {
      setSubmitting(false);
      ToastMessage("error", (error as Error)?.message);
    }
  },
})(C);
